import { render, staticRenderFns } from "./edit_submission_form.vue?vue&type=template&id=2b532ebf&scoped=true&"
import script from "./edit_submission_form.vue?vue&type=script&lang=js&"
export * from "./edit_submission_form.vue?vue&type=script&lang=js&"
import style0 from "./edit_submission_form.vue?vue&type=style&index=0&id=2b532ebf&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b532ebf",
  null
  
)

export default component.exports